import GraphicType from './GraphicType';

export default function getGraphicType(apiValue: string, isAvailable: boolean) {
  if (isAvailable) {
    return apiValue as GraphicType;
  }

  if (apiValue === GraphicType.EmptySet) {
    return GraphicType.EmptySet;
  }

  return GraphicType.Square;
}
